import { Component, ViewChild } from "@angular/core";
import { IBusinessDevelopmentContactModel, IDropdownModel } from "@models";
import { SleepService, BusinessDevelopmentService, LookupService } from "@services";
import { ContactEditComponent } from "@components/contacts";
import { SlickDialogComponent } from "slick-components";
import { BusinessDevelopmentContactRolesComponent } from "./business-development-contact-roles-dialog/business-development-contact-roles-dialog.component";

@Component({
    selector: "business-development-contact-edit-dialog",
    templateUrl: "business-development-contact-edit-dialog.component.html",
    standalone: false
})

export class BusinessDevelopmentContactEditDialogComponent {
	@ViewChild("dialogRef") dialogRef: SlickDialogComponent;
	@ViewChild("contactEditRef") contactEditRef: ContactEditComponent;
	@ViewChild("businessDevelopmentContactRolesDialogRef") businessDevelopmentContactRolesDialogRef: BusinessDevelopmentContactRolesComponent;
	businessDevelopmentContact: IBusinessDevelopmentContactModel;

	spinnerStatus: string;
	isSubmitted: boolean = false;
	rolesDropDown: IDropdownModel[] = [];

	resolve: any;

	constructor(private businessDevelopmentService: BusinessDevelopmentService,
		private lookupService: LookupService) {
	}

	async showDialog(businessDevelopmentContact: IBusinessDevelopmentContactModel): Promise<IBusinessDevelopmentContactModel> {
		this.isSubmitted = false;
		this.spinnerStatus = "reset";
		this.rolesDropDown = await this.lookupService.getBusinessDevelopmentContactRolesForDropdown();
		this.businessDevelopmentContact = businessDevelopmentContact;

		return new Promise<IBusinessDevelopmentContactModel>((resolve) => {
			this.resolve = resolve;

			this.dialogRef.showDialog();
		});

	}
	async editRoles() {
		await this.businessDevelopmentContactRolesDialogRef.showDialog();

		this.rolesDropDown = await this.lookupService.getBusinessDevelopmentContactRolesForDropdown();

	}

	validate(): boolean {
		this.isSubmitted = true;

		if (!this.contactEditRef.validate())
			return false;

		return true;
	}

	async onSave() {
		try {
			// Any validation needs to go here
			if (this.validate() === false) {
				this.spinnerStatus = "error";
				return;
			}

			this.spinnerStatus = "spin";

			await SleepService.sleep(500);

			if (this.businessDevelopmentContact.businessDevelopmentContactId === 0)
				this.businessDevelopmentContact = await this.businessDevelopmentService.addBusinessDevelopmentContact(this.businessDevelopmentContact);
			else
				this.businessDevelopmentContact = await this.businessDevelopmentService.updateBusinessDevelopmentContact(this.businessDevelopmentContact);

			await this.lookupService.refreshBusinessAccounts();

			this.spinnerStatus = "ok";

			this.resolve(this.businessDevelopmentContact);

			await SleepService.sleep(1000);

			this.dialogRef.hideDialog();

		}
		catch (error) {
			console.error(error);
			this.spinnerStatus = "error";
		}
	}

	onCancel() {
		this.resolve(null);
		this.dialogRef.hideDialog();
	}
}
